import { useState } from 'react';

const showMoreSearchParam = 'showmore';

const buildUrl = (href: string, expanded: boolean): string => {
  const url = new URL(href);
  url.searchParams.set(showMoreSearchParam, String(expanded));
  return url.toString();
};

export function useExpandedSummary(): {
  isSummaryExpanded: boolean;
  handleSummaryExpanded: (expanded: boolean) => void;
  returnUrl: string;
  syncReturnUrlWithLocation: () => void;
} {
  const [href, setHref] = useState(() => window.location.href);

  const [isSummaryExpanded, setIsSummaryExpanded] = useState(
    () => new URLSearchParams(window.location.search).get(showMoreSearchParam) === 'true'
  );

  const handleSummaryExpanded = (expanded: boolean): void => {
    const newHref = buildUrl(href, expanded);
    window.history.pushState({}, '', newHref);
    setHref(newHref);
    setIsSummaryExpanded(expanded);
  };

  const syncReturnUrlWithLocation = (): void => setHref(window.location.href);

  return { isSummaryExpanded, handleSummaryExpanded, returnUrl: buildUrl(href, isSummaryExpanded), syncReturnUrlWithLocation };
}
